<mat-list-item [ngClass]="{ 'heating': heating, 'cooling': cooling }">
    <div mat-list-icon>
        <dl-display-info-icon *ngIf="!isGauge()"
                           [displayIcon]="displayIcon"
                           [heating]="heating"
                           [cooling]="cooling">
        </dl-display-info-icon>
        <dl-gauge *ngIf="isGauge()" [item]="getGauge()"></dl-gauge>
    </div>
    <span class="value" *ngIf="!hideValue"><b>{{ getValue() + getUnits() }}</b></span>
    <div mat-line class="title">{{ getTitle() }}</div>
    <div *ngIf="item.categories && item.categories[0]" mat-line class="subtitle">{{getSubtitle()}}</div>
</mat-list-item>
